<template>
  <div class="partners-unique_mobile">
    <div class="partners-bg-unique">
      <el-row>
        <el-col :span="24">
          <div class="tilBig-unique">战略合作伙伴</div>
          <p class="description-unique">
            <span class="desc-span-unique"
              >2014年成立至今，华软科技股份有限公司在</span
            >
            <span class="desc-span-bold-unique"
              >电力行业、能源、公共安全、轨道交通、边海防、矿业、环保、港口、基础建设</span
            >
            <span class="desc-span-unique">等领域，提供以</span>
            <span class="desc-span-bold-unique">无人化、集群化、智能化</span>
            <span class="desc-span-unique">为核心的专业化解决方案。</span>
          </p>
        </el-col>
      </el-row>
    </div>
    <img src="@/assets/home/parterNew.png"  style="width: 100%; height: auto; padding: 0 6px;"/>
    <!-- <img src="@/assets/img/hzhb-icon.webp"  style="width: 100%; height: auto; padding: 0 6px;"/> -->
  </div>
</template>

<script>
export default {
  name: "Partners",
  data() {
    return {
      parterBg: require("../../assets/home/paterNewMobile.png"), // 添加背景图片引用
    };
  },
};
</script>

<style lang="scss" scoped>
.partners-unique_mobile {
  width: 100%;

  text-align: left;

  background-image: url("../../assets/img/hzhb-back.webp");
  // background-image: url('../../assets/home/paterImg.png');
  height: 365px;
  /* 设置背景图片 */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* height: 692PX; */
  /* 根据1920分辨率设置高度 */
  // padding: 16px;
  padding-top: 40px;
  .partners-bg-unique {
    padding: 0 16px;
  }

  .tilBig-unique {
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: normal;
    color: #1e242a;
  }
}

.description-unique {
  font-size: 12px;
  color: #1e242a;
  line-height: 1.8;
  margin: 10px 0;
  /* max-width: 400PX; */
}

.desc-span-unique {
  /* 可根据需要添加通用样式 */
  color: #1e242a;
  opacity: 0.8;
}

.desc-span-bold-unique {
  font-weight: bold;
  color: #1e242a;
  // opacity: 0.8;
}

.hexagon-grid-unique {
  height: 243px;
  /* 设置宽度为748PX */
  /* height: 531PX; */
  /* 设置高度为531PX */
  background-image: url("../../assets/home/paterNewMobile.png");
  /* 背景图片 */
  background-size: cover;
  /* 确保图片完全覆盖 */
  background-position: center;
  background-repeat: no-repeat;

  /* 居中显示 */
}
</style>
